export const text = {
  PATIENT_INFORMATION: 'Patient information',
  SEARCH_BY_BLURB: 'Search by patient’s MRN, email, first or last name',
  DOB: 'DOB (age/sex)',
  PHONE_NUMBER: 'Phone number',
  EMAIL: 'Email',
  PATIENT_NAME: 'Patient name*',
  ADDRESS: 'Address',
  CURRENT_VISIT: 'Current visit',
}

export const styles = {
  INPUT_STYLE: { width: 'calc(50% - 12px)' },
  PHONE_INPUT_STYLE: { flex: 1 },
  FULL_NAME_INPUT_STYLE: { width: '100%' },
  ADDRESS_STYLE: { width: '100%' },
  COUNTRY_PICKER_BUTTON_STYLE: {
    border: 'none',
    borderRadius: '4px 0 0 4px',
    backgroundColor: '#eff3f6',
  },
  COUNTRY_PICKER_CONTAINER_STYLE: {
    backgroundColor: 'transparent',
  },
  COUNTRY_PICKER_DROPDOWN_STYLE: {
    background: '#eff3f6',
    fontFamily: 'Helvetica',
    fontWeight: '400',
    fontSize: 16,
    width: 603,
  },
  COUNTRY_PICKER_INPUT_STYLE: {
    height: 60,
    border: 'none',
    borderRadius: 0,
    background: 'transparent',
    paddingLeft: 0,
    color: 'black',
  },
  INPUT_ERROR_STYLE: {
    right: 46,
  },
  PHONE_ERROR_STYLE: { position: 'absolute', bottom: -35 },
}
